import React from 'react';
import { Path, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface SearchIconProps {
  size?: number;
  color?: keyof AppColors;
}

export const SearchIcon: React.FC<SearchIconProps> = ({
  size = 12,
  color = 'iconPrimary',
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg width={size} height={size} viewBox="0 0 12 12">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3689 10.1903C11.5512 10.3941 11.5424 10.7056 11.3488 10.8987L10.9029 11.3474C10.8069 11.4447 10.6757 11.5 10.5389 11.5C10.4027 11.5 10.2723 11.4455 10.1764 11.349L8.49975 9.71504C8.42185 9.63657 8.35111 9.55125 8.28831 9.46015L7.9288 8.97766C7.13169 9.56394 6.16838 9.88149 5.17741 9.88128C2.99763 9.88872 1.10491 8.37524 0.618273 6.23874C0.131656 4.10234 1.18024 1.91072 3.14514 0.961956C5.11041 0.0130119 7.46628 0.561526 8.81783 2.28157C10.1263 3.94683 10.1558 6.28027 8.91301 7.97472L9.38244 8.30076C9.49261 8.37203 9.59445 8.45551 9.68607 8.54961L11.3689 10.1903ZM5.17707 8.40335C3.41443 8.40335 1.98553 6.96507 1.98553 5.19085C1.98553 3.41663 3.41443 1.97834 5.17707 1.97834C6.93971 1.97834 8.36861 3.41663 8.36861 5.19085C8.36861 6.04286 8.03236 6.85997 7.43383 7.46243C6.8353 8.06489 6.02352 8.40335 5.17707 8.40335Z"
        fill={colors[color]}
      />
    </Svg>
  );
};
